<template>
	<v-dialog 
		v-resize="onResize"
		v-model="visible"
		transition="dialog-bottom-transition"
		scrollable
		persistent
		lazy
		max-width="600"
		:fullscreen="isFullscreen">

		<v-card>
			<v-card-title class="pa-0">
				<v-toolbar dense dark color="primary" card>
					<v-toolbar-title>{{ $t('FEEDBACK_NEW_TITLE') }}</v-toolbar-title>
					<v-spacer></v-spacer>
					<v-toolbar-items>
						<v-btn flat small @click="cancel" class="hidden-xs-only">{{ $t('GENERAL_BUTTON_CANCEL') }}</v-btn>
						<v-btn flat small @click="submit" class="hidden-xs-only">{{ $t('GENERAL_BUTTON_SAVE') }}</v-btn>
						<v-btn icon small @click="cancel" class="hidden-sm-and-up"><v-icon>mdi-close</v-icon></v-btn>
						<v-btn icon small @click="submit" class="hidden-sm-and-up"><v-icon>mdi-check</v-icon></v-btn>
					</v-toolbar-items>
				</v-toolbar>
			</v-card-title>

			<v-card-text>
				<v-form ref="form" v-model="valid">
					<v-container fluid grid-list-lg>
						<v-layout wrap class="mb-3">
							<span class="subheading">{{ $t('FEEDBACK_HEADER_ACTION_CONTEXT') }}</span>
						</v-layout>

						<v-layout wrap>
							<v-flex xs12>
								<v-menu
									v-model="datePickerVisible"
									:close-on-content-click="false"
									:nudge-right="40"
									full-width
									max-width="290"
									transition="scale-transition"
									offset-y>

									<v-text-field
										slot="activator"
										box
										hide-details
										prepend-inner-icon="mdi-calendar"
										:label="$t('FEEDBACK_LABEL_DATE')"
										:rules="[rules.required]"
										:value="item.date | toSimpleDate"
										readonly />

									<v-date-picker v-model="item.date" :locale="$i18n.locale" no-title @change="datePickerVisible = false" />
								</v-menu>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									box hide-details clearable
									:label="$t('FEEDBACK_LABEL_CITY')"
									:rules="[rules.required]"
									v-model="item.city" />
							</v-flex>
							<v-flex xs12>
								<v-select
									box hide-details
									:label="$t('FEEDBACK_LABEL_AREA')"
									:rules="[rules.required]"
									:items="areas"
									v-model="item.area" />
							</v-flex>
							<v-flex xs12>
								<markdown-editor :label="$t('FEEDBACK_LABEL_CONTEXT_DETAILS')" rows="3" v-model="item.context"/>
							</v-flex>
						</v-layout>
					</v-container>

					<v-container fluid grid-list-lg>
						<v-layout wrap class="mb-3">
							<span class="subheading">{{ $t('FEEDBACK_HEADER_ACTION_DETAILS') }}</span>
						</v-layout>

						<v-layout wrap>
							<v-flex xs12>
								<markdown-editor :label="$t('FEEDBACK_LABEL_PREPARATION')" rows="3" v-model="item.preparation"/>
							</v-flex>
							<v-flex xs12>
								<markdown-editor :label="$t('FEEDBACK_LABEL_EXECUTION')" rows="3" v-model="item.execution"/>
							</v-flex>
							<v-flex xs12>
								<markdown-editor :label="$t('FEEDBACK_LABEL_CONVICTIONS')" rows="3" v-model="item.convictions"/>
							</v-flex>
						</v-layout>
					</v-container>

					<v-container fluid grid-list-lg align-center justify-center>
						<v-layout wrap class="mb-3">
							<span class="subheading">{{ $t('FEEDBACK_HEADER_FEEDBACK') }}</span>
						</v-layout>

						<v-layout wrap>
							<v-flex xs12>
								<v-layout wrap align-center>
									<div class="ml-2 mr-3">{{ $t('FEEDBACK_LABEL_RATING') }} :</div>
									<v-rating
										dense
										hover
										color="yellow darken-1"
										:background-color="ratingBGColor"
										:rules="[rules.required]"
										v-model="item.rating" />
								</v-layout>
							</v-flex>
							<v-flex xs12>
								<markdown-editor :label="$t('FEEDBACK_LABEL_RECOMMENDATIONS')" rows="3" v-model="item.recommendations"/>
							</v-flex>
						</v-layout>
					</v-container>
				</v-form>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>


<script>
import { mapGetters, mapState } from 'vuex';
import { toSimpleDate } from '@/utils/formatters';
import MarkdownEditor from '@/components/MarkdownEditor';

export default {
	name: "dialog-feedback-form",
	components: { MarkdownEditor },
	data(self) { return {
		currentWidth: window.innerWidth,
		datePickerVisible: false,
		valid: false,
		rules: {
			required(value) {
				return typeof value === 'string' && !!value.trim() || self.$t('GENERAL_VALIDATION_ERROR_REQUIRED');
			},
		},
	}},
	computed: {
		isFullscreen() {
			return this.currentWidth < 600;
		},
		...mapState(['areas']),
		...mapGetters('feedbacks', {
			item: 'editDialogCopy',
			visible: 'editDialogVisible',
		}),
		isRatingValid() {
			return !!this.item.rating;
		},
		ratingBGColor() {
			return this.isRatingValid ? 'grey lighten-1' : 'red';
		},
	},
	filters: {
		toSimpleDate,
	},
	methods: {
		onResize() {
			this.currentWidth = window.innerWidth;
		},
		validate() {
			const isFormValid = this.$refs['form'].validate();
			return isFormValid && this.isRatingValid;
		},
		submit() {
			if (!this.validate()) { return }
			this.$store.dispatch('feedbacks/saveFeedback', { item: this.item });
		},
		cancel() {
			this.$store.dispatch('feedbacks/cancelFeedbackChanges', { item: this.item });
			this.$refs['form'].resetValidation();
		},
	},
}
</script>


<style lang="less" scoped>
</style>
